import React, { useEffect } from 'react';
import { Plus } from 'lucide-react';
import ConversationItem from './ConversationItem';
import Button from '../../../button/button';
import styles from './ConversationsSidebar.scss';

const ConversationsSidebar = ({
  conversations,
  activeConversationId,
  onSelectConversation,
  onCreateNew,
  onUpdateTitle,
  onDeleteConversation,
  onExportToPDF,
  isLoading,
  isLoadingConversations,
  isCreatingConversation,
  isExporting,
  isLightMode
}) => {
  return (
    <div className={`${styles.conversationsSidebar} ${isLightMode ? styles.lightMode : ''}`}>
      <div className={styles.sidebarHeader}>
        <h4>Conversations</h4>
        <Button
          onClick={onCreateNew}
          className={styles.sidebarHeaderButton}
          title="New Conversation"
          icon={<Plus size={16} />}
          disabled={isLoading || isCreatingConversation}
        />
      </div>
      
      <div className={styles.sidebarContent}>
        {isLoadingConversations ? (
          <div className={styles.sidebarLoading}>
            <div className={styles.loadingSpinner} />
            <span>Loading...</span>
          </div>
        ) : conversations.length === 0 ? (
          <div className={styles.sidebarEmpty}>
            <p>No conversations yet</p>
          </div>
        ) : (
          <div className={styles.conversationsList}>
            {conversations.map((conv) => (
              <ConversationItem
                key={`${conv.conversation_id}-${conv.title || conv.preview || 'untitled'}-${conv.message_count}`}
                conversation={conv}
                isActive={activeConversationId === conv.conversation_id}
                onSelect={onSelectConversation}
                onUpdateTitle={onUpdateTitle}
                onDelete={onDeleteConversation}
                onExport={onExportToPDF}
                isExporting={isExporting}
                isLightMode={isLightMode}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ConversationsSidebar;

